@if (isPhoenix || (isHomesite$ | async)) {
  <ds-payment-review-wrapper-hs-phoenix />
} @else {
  <div class="payment-review-container">
    <div class="flex">
      @if (paymentError$ | async) {
        <span class="pseudo-icon error"></span>
      }
      <h3 data-cy="reviewPaymentHeader">
        {{ (paymentError$ | async) ? paymentErrorHeading : heading }}
      </h3>
    </div>
    <div class="go-back-box">
      <button
        ds-button
        class="-outline-white"
        (click)="goBack()"
        data-cy="editPaymentSelectionButtonText"
      >
        <i class="icon-chevron-left-thick"></i>
        <span data-cy="editPaymentSelectionButton">Edit Payment Selection</span>
      </button>
      @if ((paymentError$ | async) === undefined) {
        <p data-cy="goBackText">{{ goBackText }}</p>
      }
      @if (paymentError$ | async) {
        <p class="error-message" data-cy="paymentErrorMessage">
          {{ paymentError$ | async }}
        </p>
      }
    </div>

    <div>
      @for (account of (simplifiedPaymentInfo$ | async).selectedBillAccounts; track account) {
        <div class="margin-bottom-30">
          <div class="flex">
            <p class="margin-right-5" data-cy="youArePayingText">You're paying:</p>
            <p class="bold" data-cy="accountNickName">{{ account.nickName }}</p>
          </div>
          <div class="flex">
            <p class="row truncate-string-ellipsis margin-right-5" data-cy="accountRisk">
              {{ account.risk }}
            </p>
            <p class="amount" data-cy="selectedPaymentAmount">{{ account.amount | currencyUSD }}</p>
          </div>
        </div>
      }
    </div>

    <div class="flex">
      <p class="margin-right-5" data-cy="selectedPaymentMethodText">Payment method:</p>
      <p class="bold" data-cy="selectedPaymentMethod">
        {{ (simplifiedPaymentInfo$ | async).paymentMethodNickName }}
      </p>
    </div>
    <div class="flex">
      <p class="margin-right-5" data-cy="selectedPaymentDateText">Payment date:</p>
      <p class="bold" data-cy="selectedPaymentDate">
        {{ (simplifiedPaymentInfo$ | async).paymentDate }}
      </p>
    </div>

    <div class="total">
      <p class="total-text" data-cy="totalText">Total:</p>
      <p class="total-amount" data-cy="totalAmountText">
        {{ (simplifiedPaymentInfo$ | async).totalAmount | currencyUSD }}
      </p>
    </div>
    <ds-payment-terms-and-conditions
      [(visible)]="showTermsAndConditionsModal"
      [isPartner]="isPartner$ | async"
      [paymentType]="termsAndConditionsType"
      [partnerContent]="termsAndConditionsPartnerContent$ | async"
      (agreeTermsAndConditionsEvent)="agreeTermsAndConditionsEvent($event)"
      data-cy="paymentTermsAndConditions"
    >
    </ds-payment-terms-and-conditions>
  </div>

  <div class="sticky-container">
    <call-to-action
      [secondaryButtonName]="'Cancel'"
      [primaryButtonName]="
        'Pay now ' + ((simplifiedPaymentInfo$ | async).totalAmount | currencyUSD)
      "
      [disablePrimaryButton]="
        (roleService.isAuthorized('makemyacctpayment_submit_disable') | async) === false ||
        isDisabledAfterClick
      "
      (primaryEvent)="preSubmit()"
      (secondaryEvent)="cancel()"
    ></call-to-action>
  </div>

  <ds-alert-modal
    [config]="cancelModalConfig"
    (primaryEvent)="leave()"
    (tertiaryEvent)="stay()"
  ></ds-alert-modal>

  <ds-duplicate-payment-confirmation-modal
    (handleYes)="handleModalYes()"
    (handleNo)="handleModalNo()"
  >
  </ds-duplicate-payment-confirmation-modal>
}
